"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var $installBtn = $('.technology-buttons__how-to-install-btn');
    var $returnBtn = $('.technology-buttons__return_to');
    var $scrollUpBtn = $('.scroll-btn-smart');
    var $smartBadges = $('.smart-integrations-features');
    var $badges = $('.section-btn-scroll');
    var $badgesInner = $('.badges');
    var $technologyHowToInstallDescription = '.technology-text__how-to-install';
    var $technologyDescription = '.technology-text__description';
    var $technologySections = $('.smart-integration-features-technology__content-wrapper');
    //How to install information -  display none
    $($technologyHowToInstallDescription).fadeOut();
    $($returnBtn.fadeOut());
    function enableEvents() {
        scrollToSectionUrl();
        $badges.on('click', badgesActive);
        $installBtn.on('click', howToInstallTextChange);
        $returnBtn.on('click', howToInstallTextChange);
        $scrollUpBtn.on('click', scrollToBadgesUp);
        $(window).on('scroll', scrollFunction);
    }
    var scrollToBadgesUp = function () { return $(window).scrollTop($smartBadges.offset().top); };
    var scrollFunction = function () { return ($(window).scrollTop() > $smartBadges.offset().top + 70 ? $scrollUpBtn.fadeIn() : $scrollUpBtn.fadeOut()); };
    var badgesActive = function (e) {
        e.preventDefault();
        var sectionNumber = (Array.from($('.badges')).indexOf(e.target));
        var sectionScrollPosition = $("#technology-section-".concat(sectionNumber)).offset().top;
        $([document.documentElement, document.body]).animate({
            scrollTop: sectionScrollPosition
        }, 100);
        window.location.hash = "technology-section-".concat(sectionNumber);
        $badgesInner.removeClass('active');
        $(e.target).addClass('active');
    };
    var howToInstallTextChange = function (event) {
        var description = $(this).parents('.technology-content').children('.technology-text').children($technologyDescription);
        var howToInstall = $(this).parents('.technology-content').children('.technology-text').children($technologyHowToInstallDescription);
        howToInstall.toggleClass('how-to-install-active');
        description.toggleClass('how-to-install-active');
        if (howToInstall.hasClass('how-to-install-active')) {
            howToInstall.delay(530).slideToggle();
            description.slideToggle();
            $(this).fadeOut();
            $(this).siblings('.technology-buttons__return_to').delay(400).fadeIn();
            $(this).siblings('.technology-buttons__return_to').addClass('active-btn');
        }
        else {
            howToInstall.slideToggle();
            description.delay(530).slideToggle();
            $(this).siblings('.technology-buttons__how-to-install-btn').delay(400).fadeIn();
            $(this).fadeOut();
            $(this).removeClass('active-btn');
        }
    };
    function scrollToSectionUrl() {
        var number = $technologySections.length;
        var _loop_1 = function (i) {
            if (window.location.href.indexOf("#technology-section-".concat(i)) > -1) {
                setTimeout(function () { $(window).scrollTop($("#banner-".concat(i)).offset().top); }, 1000);
            }
        };
        for (var i = 0; i < number; i++) {
            _loop_1(i);
        }
    }
    if ($('.badges').length) {
        $(window).on('load', enableEvents);
    }
};
exports.init = init;
